import { render, staticRenderFns } from "./VipImgView.vue?vue&type=template&id=2ebb937e&"
import script from "./VipImgView.vue?vue&type=script&lang=js&"
export * from "./VipImgView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports